import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import utils from 'utils';
import conf from 'config';
import useUserInfo from 'app/hooks/user/useUserInfo';

function JSONParse(maybeJSON: any): any {
  const result = {};

  try {
    let source;
    if (typeof maybeJSON === 'object' && maybeJSON !== null) source = maybeJSON;
    else source = JSON.parse(maybeJSON);
    Object.assign(result, source);
  } catch (e) {
    // console.error('Window Post messages parsing error: ', e);
  }

  return result;
}

const WHITE_LIST_ORIGIN = ((env) => {
  const iframeOrigin = conf.iframeOrigin.replace('/#/authenticated', '');
  const whiteListedOrigin = [
    iframeOrigin,
    'https://billing.guestyforhosts.com',
  ];

  if (env === 'production') {
    whiteListedOrigin.push(window.location.origin);
  } else {
    whiteListedOrigin.push(
      'http://localhost:3000',
      'https://app-staging1.guestyforhosts.com',
      'https://billing-staging1.guestyforhosts.com'
    );
  }

  return whiteListedOrigin;
})(process.env.NODE_ENV);

function useOnMessagingCommunication() {
  const history = useHistory();
  const { refetchBaseUserInfo } = useUserInfo();

  useEffect(() => {
    function onMessage(event: MessageEvent<any>) {
      if (WHITE_LIST_ORIGIN.includes(event.origin)) {
        const locationState = history.location.state || {};
        const json = JSONParse(event.data);

        switch (json.key) {
          case 'openWindow': {
            window.open(json.data.url, json.data.target);
            break;
          }

          case 'logout': {
            history.replace('/logout', {});

            break;
          }

          case 'stateChange': {
            const { toState } = json.data;
            const nextPathname = toState.completePath.replace(
              '/authenticated',
              ''
            );

            history.replace(nextPathname, {
              ...locationState,
            });

            break;
          }

          case 'navigate': {
            history.push(`/${json.data.page}`, {
              ...locationState,
            });

            break;
          }

          case 'dateFormatterChangeValue': {
            utils.changeDateFormat(json.data);
            break;
          }

          case 'updateUserInfo': {
            utils.setLocalStorage(json.data);
            break;
          }

          case 'fetchUserInfo': {
            refetchBaseUserInfo();
            break;
          }

          default: {
            break;
          }
        }
      }
    }

    window.addEventListener('message', onMessage);

    return function unmount() {
      window.removeEventListener('message', onMessage);
    };
  }, []);
}

export default useOnMessagingCommunication;
